__turbopack_context__.v({
  "bestTimeSelectContainer": "BorLEG_bestTimeSelectContainer",
  "checkbox": "BorLEG_checkbox",
  "checkboxContainer": "BorLEG_checkboxContainer",
  "checkboxLabel": "BorLEG_checkboxLabel",
  "comments": "BorLEG_comments",
  "commentsContainer": "BorLEG_commentsContainer",
  "emptyColumn": "BorLEG_emptyColumn",
  "inputError": "BorLEG_inputError",
  "isCentered": "BorLEG_isCentered",
  "modalBackdrop": "BorLEG_modalBackdrop",
  "modalCloseButton": "BorLEG_modalCloseButton",
  "modalColumnOne": "BorLEG_modalColumnOne",
  "modalColumnTwo": "BorLEG_modalColumnTwo",
  "modalContainer": "BorLEG_modalContainer",
  "modalForm": "BorLEG_modalForm",
  "modalHeader": "BorLEG_modalHeader",
  "modalHeaderContainer": "BorLEG_modalHeaderContainer",
  "modalInput": "BorLEG_modalInput",
  "modalSelectInput": "BorLEG_modalSelectInput",
  "modalSelectWrapper": "BorLEG_modalSelectWrapper",
  "selectLabel": "BorLEG_selectLabel",
  "submitButtonContainer": "BorLEG_submitButtonContainer",
  "submitContainer": "BorLEG_submitContainer",
  "white": "BorLEG_white",
});
